define("shared/components/shared/trial-countdown", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!-- Trial Plan Counter --}}
  {{#if this.hasActiveTrial}}
    <div class="cTC--wrapper u--hide--mobile" data-test-id="trial-countdown">
      <LinkTo @route={{if @route @route "account.overview"}} class="cTC--container">
        {{!-- Button Bg --}}
        <svg xmlns="http://www.w3.org/2000/svg" width="167" height="38" viewBox="0 0 167 38" class="cTC--button">
          <rect width="165" height="36" x="0" y="0" fill="#E6F9F3" stroke-width="1" fill-rule="evenodd" rx="18" transform="translate(1 1)"/>
        </svg>
        {{!-- Day Count --}}
        <div class="cTC--count">
          <span class="cTC--count__item" data-test-id="days-remaining">{{this.trialDaysRemaining}}</span>
        </div>
        {{!-- Title --}}
        <span class="cTC--text" data-test-id="text">{{t "app.trial_plan_counter.title" count=this.trialDaysRemaining}}</span>
        {{!-- Emoji --}}
        {{#if (gt this.trialDaysRemaining 5)}}
          <span class="cTC--status" data-test-id="active">
            {{t "app.trial_plan_counter.emoji_active"}}
          </span>
        {{else if (gt this.trialDaysRemaining 1)}}
          <span class="cTC--status" data-test-id="warning">
            {{t "app.trial_plan_counter.emoji_warning"}}
          </span>
        {{else}}
          <span class="cTC--status" data-test-id="alert">
            {{t "app.trial_plan_counter.emoji_alert"}}
          </span>
        {{/if}}
      </LinkTo>
    </div>
  {{/if}}
  
  */
  {
    "id": "91hkyXO+",
    "block": "[[[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"  \"],[10,0],[14,0,\"cTC--wrapper u--hide--mobile\"],[14,\"data-test-id\",\"trial-countdown\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"cTC--container\"]],[[\"@route\"],[[52,[30,1],[30,1],\"account.overview\"]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[10,\"svg\"],[14,\"xmlns\",\"http://www.w3.org/2000/svg\",\"http://www.w3.org/2000/xmlns/\"],[14,\"width\",\"167\"],[14,\"height\",\"38\"],[14,\"viewBox\",\"0 0 167 38\"],[14,0,\"cTC--button\"],[12],[1,\"\\n        \"],[10,\"rect\"],[14,\"width\",\"165\"],[14,\"height\",\"36\"],[14,\"x\",\"0\"],[14,\"y\",\"0\"],[14,\"fill\",\"#E6F9F3\"],[14,\"stroke-width\",\"1\"],[14,\"fill-rule\",\"evenodd\"],[14,\"rx\",\"18\"],[14,\"transform\",\"translate(1 1)\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cTC--count\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"cTC--count__item\"],[14,\"data-test-id\",\"days-remaining\"],[12],[1,[30,0,[\"trialDaysRemaining\"]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,1],[14,0,\"cTC--text\"],[14,\"data-test-id\",\"text\"],[12],[1,[28,[35,2],[\"app.trial_plan_counter.title\"],[[\"count\"],[[30,0,[\"trialDaysRemaining\"]]]]]],[13],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"trialDaysRemaining\"]],5],null],[[[1,\"        \"],[10,1],[14,0,\"cTC--status\"],[14,\"data-test-id\",\"active\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"app.trial_plan_counter.emoji_active\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,0,[\"trialDaysRemaining\"]],1],null],[[[1,\"        \"],[10,1],[14,0,\"cTC--status\"],[14,\"data-test-id\",\"warning\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"app.trial_plan_counter.emoji_warning\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"cTC--status\"],[14,\"data-test-id\",\"alert\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"app.trial_plan_counter.emoji_alert\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@route\"],false,[\"if\",\"link-to\",\"t\",\"gt\"]]",
    "moduleName": "shared/components/shared/trial-countdown.hbs",
    "isStrictMode": false
  });

  let TrialCountdownComponent = (_class = class TrialCountdownComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);
    }

    get hasActiveTrial() {
      return this.auth.currentAccount.hasActiveTrial;
    }

    get trialDaysRemaining() {
      return this.auth.currentAccount.trialDaysRemaining;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = TrialCountdownComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TrialCountdownComponent);
});